import { getState } from '../../store';

export function isResourcePaginated () {
  const state = getState();
  return state && state.featureFlags && state.featureFlags.flags.resource_pagination;
}
